import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dataset-coverage-map',
  templateUrl: './dataset-coverage-map.component.html',
  styleUrls: ['./dataset-coverage-map.component.scss'],
})
export class DatasetCoverageMapComponent implements OnInit {
  @Input() countries: Array<any>;
  tooltipDiv = null;
  highlighted = null;

  constructor() {}

  ngOnInit() {
    this.initCoverageMap();
    this.tooltipDiv = document.querySelector<HTMLElement>('[data-coverage-tooltip]');
  }

  initCoverageMap(): void {
    this.countries.map((country) => {
      // Skip this step if data not available
      if (country.ISO === '') {
        return;
      }

      let iso = country.ISO;
      var shape = document.querySelectorAll('.' + iso);
      Array.from(shape).forEach((item) => {
        item.classList.add('available');
      });
    });
  }

  onMouseOver(event: any): void {
    let item = event.target;
    if (item.classList.contains('available')) {
      item.classList.add('hover');
      this.highlighted = item.dataset.countryName;
      this.positionDescription();
    }
  }

  onMouseLeave(event: any): void {
    let item = event.target;
    item.classList.remove('hover');
    this.highlighted = null;
  }

  resetTooltipPosition(): void {
    this.tooltipDiv.style.left = '0px';
    this.tooltipDiv.style.top = '0px';
  }

  positionDescription(): void {
    let shape = document.querySelector<HTMLElement>(`[data-country-name="${this.highlighted}"]`);
    this.resetTooltipPosition();
    var tooltipRect = this.tooltipDiv.getBoundingClientRect();
    var svgRect = shape.getBoundingClientRect();
    var offsetTop = svgRect.top - 50;
    var halfTooltipWidth = this.tooltipDiv.clientWidth / 2;
    var halfSVGWidth = svgRect.width / 2;

    this.tooltipDiv.style.left =
      svgRect.left + halfSVGWidth - halfTooltipWidth - tooltipRect.left + 'px';
    this.tooltipDiv.style.top = offsetTop - tooltipRect.top + 'px';
  }
}
